<template>
  <div class="model-brand-page">
    <el-row>
      <el-col :md="7" class="hidden-md-and-up">
        <el-row class="box-1">
          <el-col class="box-1-3-1" :md="24" :span="15">
            <div class="big font-bold wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand1") }}
            </div>
            <div class="big font-black wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand2") }} <span>{{ $t("brand3") }}</span>
            </div>
            <div class="font-bold wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand4") }}
              <span class="font-black">{{ $t("brand5") }}</span>
            </div>
            <div class="font-bold wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand6") }}
            </div>
          </el-col>
          <el-col class="box-1-3-2" :md="24" :span="9"></el-col>
        </el-row>
      </el-col>
      <el-col :md="11" :span="15">
        <div class="img-box box-1 img-1-1"></div>
      </el-col>
      <el-col :md="6" :span="9">
        <div class="img-box box-1 img-1-2"></div>
      </el-col>
      <el-col :md="7" class="hidden-sm-and-down">
        <el-row class="box-1">
          <el-col class="box-1-3-1" :md="24" :span="16">
            <div class="big font-bold wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand1") }}
            </div>
            <div class="big font-black wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand2") }} <span>{{ $t("brand3") }}</span>
            </div>
            <div class="font-bold wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand4") }}
              <span class="font-black">{{ $t("brand5") }}</span>
            </div>
            <div class="font-bold wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("brand6") }}
            </div>
          </el-col>
          <el-col class="box-1-3-2" :md="24" :span="8"></el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" :md="11">
        <div class="box-2">
          <div class="box-2-1">
            <div class="text-box">
              <div class="wow fadeInUp font-bold" data-wow-delay="0.5s">
                {{ $t("brand7") }}
              </div>
              <div class="wow fadeInUp font-black" data-wow-delay="0.5s">
                {{ $t("brand8") }} ?
              </div>
            </div>
            <div
              class="bg-text-box font-bold wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div>{{ $t("brand7").toLocaleUpperCase() }}</div>
              <div>{{ $t("brand8").toLocaleUpperCase() }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="24" :md="13">
        <div class="box-2 img-box img-2-2">
          <video
            ref="brandVideo"
            src="../../assets/video/Ora_GT_video.mp4"
            autoplay
            loop
            muted="muted"
            webkit-playsinline="true"
            playsinline="true"
          ></video>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="10" :span="14">
        <div class="box-3">
          <div class="box-3-1 img-box"></div>
        </div>
      </el-col>
      <el-col :md="7" class="hidden-sm-and-down">
        <div class="box-3">
          <div class="box-3-2">
            <div class="big wow fadeInUp font-bold" data-wow-delay="0.2s">
              <span>{{ $t("brand9") }}</span>
            </div>
            <div class="wow fadeInUp font-light" data-wow-delay="0.5s">
              {{ $t("brand10") }}
              <span class="font-bold">{{ $t("brand11") }}</span>
              {{ $t("brand12") }}
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="7" :span="10">
        <div class="box-3">
          <div class="box-3-3">
            <div class="text-box">
              <div class="hidden-md-and-up">
                <div class="big wow fadeInUp font-bold" data-wow-delay="0.5s">
                  <span>{{ $t("brand9") }}</span>
                </div>
                <div class="wow fadeInUp font-light" data-wow-delay="0.5s">
                  {{ $t("brand10") }}
                  <span class="font-bold">{{ $t("brand11") }}</span>
                  {{ $t("brand12") }}
                </div>
              </div>
            </div>
            <div class="bg-text-box wow fadeInRight" data-wow-delay="0.2s">
              <div class="font-bold">
                {{ $t("brand9-1") }} {{ $t("brand9-2") }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="8" :span="9">
        <div class="box-4">
          <div class="box-4-1">
            <div
              class="big wow fadeInUp font-bold"
              :class="{ de: $t('lang') == 'de' }"
              data-wow-delay="0.2s"
            >
              <span>{{ $t("brand13") }}</span>
            </div>
            <div class="wow fadeInUp font-light" data-wow-delay="0.5s">
              {{ $t("brand14") }}
            </div>
            <div class="wow fadeInUp font-bold" data-wow-delay="0.5s">
              <span>{{ $t("brand15") }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="10" :span="15">
        <div class="box-4">
          <div class="img-box img-4-2"></div>
        </div>
      </el-col>
      <el-col :span="15" class="hidden-md-and-up">
        <div class="box-4">
          <div class="img-box img-4-4"></div>
        </div>
      </el-col>
      <el-col :md="2" :span="9">
        <div class="box-4">
          <div class="box-4-3"></div>
        </div>
      </el-col>
      <el-col :md="4" class="hidden-sm-and-down">
        <div class="box-4">
          <div class="img-box img-4-4"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="8" :span="9" class="hidden-sm-and-down">
        <div class="box-5">
          <div class="img-box img-5-1"></div>
        </div>
      </el-col>
      <el-col :md="16" :span="15">
        <div class="box-5 border">
          <div class="box-5-2 wow fadeInUp" data-wow-delay="0.2s">
            <div class="big wow fadeInUp font-bold" data-wow-delay="0.2s">
              {{ $t("brand16") }}
            </div>
            <div class="big wow fadeInUp font-bold" data-wow-delay="0.2s">
              {{ $t("brand17") }}
            </div>
            <div class="wow fadeInUp font-bold" data-wow-delay="0.5s">
              {{ $t("brand18") }}
            </div>
            <div class="wow fadeInUp font-black" data-wow-delay="0.5s">
              <em>{{ $t("brand19") }}</em>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="9" class="hidden-md-and-up">
        <div class="box-5">
          <div class="img-box img-5-1"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="16" :span="24">
        <div class="box-6">
          <div class="img-box img-6-1"></div>
        </div>
      </el-col>
      <el-col :md="8" :span="24">
        <div class="box-6 box-6-2">
          <div class="box-6-2-1">
            <div class="img-box img-6-2-1"></div>
          </div>
          <div class="box-6-2-2">
            <div class="text-box" :class="{ de: $t('lang') == 'de' }">
              <div class="wow fadeInUp font-black" data-wow-delay="0.2s">
                {{ $t("brand20") }}
              </div>
              <div class="wow fadeInUp font-bold" data-wow-delay="0.2s">
                {{ $t("brand21") }}
              </div>
              <div class="wow fadeInUp font-black" data-wow-delay="0.2s">
                {{ $t("brand22") }}?
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="box-7 wow fadeInUp" data-wow-delay="0.2s">
          <div class="text-box font-light">
            <span class="font-black">{{ $t("brand4") }} </span
            >{{ $t("brand5") }}
            <span class="font-black">{{ $t("brand6") }}</span>
          </div>
          <div class="img-7-2">
            <img src="../../assets/images/brand/7-2.svg" alt="logo" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { isPhone } from "../../utils";
import { WOW } from "wowjs";
export default {
  mounted() {
    new WOW().init();
    window.addEventListener("touchstart", () => {
      if (isPhone) {
        this.$refs.brandVideo.play();
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.font-light {
  font-family: "OpenSansLight";
}
.font-bold {
  font-family: "OpenSansBold";
}
.font-black {
  font-family: "OpenSansBlack";
}
.bg-text-box {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}
.model-brand-page {
  position: relative;
  top: -213px;
  z-index: -1;
  @media (max-width: 992px) {
    position: static;
    top: 0;
  }
}
em {
  font-style: normal;
  font-weight: 700;
}
.img-box {
  height: 100%;
  background: no-repeat center center / cover;
}
.box-1 {
  height: 1080px;
  @media (max-width: 992px) {
    height: auto;
  }
}
.img-1-1 {
  @media (max-width: 992px) {
    height: 392px;
    background-image: url("../../assets/images/brand/1-1-mobile.png");
    border-top: 1px solid #666;
  }
  background-image: url("../../assets/images/brand/1-1.png");
}
.img-1-2 {
  @media (max-width: 992px) {
    height: 392px;
    background-image: url("../../assets/images/brand/1-2-mobile.png");
    background-position-x: center;
    border-top: 1px solid #666;
    border-left: 1px solid #666;
  }
  background-image: url("../../assets/images/brand/1-2.png");
}
.box-1-3-1,
.box-1-3-2 {
  height: 50%;
  @media (max-width: 992px) {
    height: 244px;
  }
}
.box-1-3-1 {
  display: flex;
  padding: 50px 0 0 10%;
  flex-direction: column;
  justify-content: center;
  font-size: 60px;
  line-height: 80px;
  color: #333;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  border: 0.5px solid #666;
  border-right: none;
  @media (max-width: 1675px) {
    line-height: 70px;
    font-size: 50px;
  }
  @media (max-width: 1390px) {
    line-height: 70px;
    font-size: 40px;
  }
  @media (max-width: 992px) {
    padding: 0 10px;
    margin-left: 0;
    margin-right: 0;
    line-height: 42px;
    font-size: 26px;
    border-left: none;
    border-bottom: none;
  }
  .big {
    font-size: 80px;
    @media (max-width: 1675px) {
      font-size: 66px;
    }
    @media (max-width: 1390px) {
      font-size: 54px;
    }
    @media (max-width: 992px) {
      font-size: 32px;
    }
  }
}
.box-1-3-2 {
  border: 1px solid #666;
  border-right-width: 0;
  border-top-width: 0;
  background-color: #67ffb8;
  @media (max-width: 992px) {
    border-top-width: 1px;
    border-bottom-width: 0;
  }
}
.box-2 {
  height: 700px;
  @media (max-width: 992px) {
    height: 257px;
  }
  .box-2-1 {
    position: relative;
    height: 100%;
    border-bottom: 1px solid #666;
    background-color: #c6e7fb;
    @media (max-width: 992px) {
      border: 1px solid #666;
    }
    .text-box {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      padding: 0 10%;
      height: 100%;
      font-size: 80px;
      color: #666;
      text-align: left;
      z-index: 1;
      white-space: nowrap;
      overflow: hidden;
      @media (max-width: 1650px) {
        font-size: 66px;
      }
      @media (max-width: 1390px) {
        font-size: 54px;
      }
      @media (max-width: 992px) {
        padding: 0 15px;
        font-size: 42px;
        line-height: 50px;
      }
    }
    .bg-text-box {
      padding-left: 10%;
      font-size: 200px;
      line-height: 160px;
      color: rgba(255, 255, 255, 0.5);
      white-space: nowrap;
      overflow: hidden;
      @media (max-width: 1650px) {
        font-size: 180px;
        line-height: 150px;
      }
      @media (max-width: 1390px) {
        font-size: 160px;
        line-height: 136px;
      }
      @media (max-width: 992px) {
        padding-left: 15px;
        font-size: 90px;
        line-height: 90px;
      }
    }
  }
}
.img-2-2 {
  // background-image: url("../../assets/images/brand/2-2.png");
  > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.box-3 {
  height: 530px;
  @media (max-width: 992px) {
    height: 204px;
  }
  .box-3-1 {
    @media (max-width: 992px) {
      background-image: url("../../assets/images/brand/3-1-mobile.png");
    }
    background-image: url("../../assets/images/brand/3-1.png");
  }
  .box-3-2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 0 0 0 10%;
    text-align: left;
    font-size: 30px;
    line-height: 40px;
    color: #131313;
    font-weight: 700;
    border: 1px solid #666;
    border-bottom: none;
    .big {
      margin-bottom: 50px;
      font-size: 90px;
      line-height: 20px;
      white-space: nowrap;
    }
  }
  .box-3-3 {
    position: relative;
    height: 100%;
    background-color: #67ffb8;
    .text-box {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
      z-index: 1;
      @media (max-width: 992px) {
        padding: 0 25px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 700;
        .big {
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 5px;
        }
      }
    }
    .bg-text-box {
      padding-left: 78px;
      font-size: 280px;
      line-height: 258px;
      color: rgba(255, 255, 255, 0.5);
      overflow: hidden;
      @media (max-width: 992px) {
        padding-left: 36px;
        font-size: 70px;
        line-height: 75px;
      }
    }
  }
}
.box-4 {
  height: 527px;
  @media (max-width: 992px) {
    height: 204px;
  }
  .box-4-1 {
    height: 100%;
    display: flex;
    padding: 0 0 0 66px;
    justify-content: center;
    flex-direction: column;
    text-align: left;
    font-size: 25px;
    line-height: 40px;
    color: #333;
    border: 1px solid #666;
    border-left: none;
    border-right: none;
    @media (max-width: 992px) {
      padding: 0 0 0 15px;
      font-size: 16px;
      line-height: 20px;
    }
    .big {
      margin-bottom: 50px;
      font-size: 90px;
      line-height: 20px;
      &.de {
        font-size: 70px;
      }
      @media (max-width: 1675px) {
        font-size: 80px;
        &.de {
          font-size: 60px;
        }
      }
      @media (max-width: 1470px) {
        font-size: 70px;
        &.de {
          font-size: 50px;
        }
      }
      @media (max-width: 992px) {
        margin-bottom: 5px;
        font-size: 30px;
        line-height: 40px;
        word-break: break-word;
        &.de {
          font-size: 30px;
        }
      }
    }
  }
  .img-4-2 {
    @media (max-width: 992px) {
      background-image: url("../../assets/images/brand/4-2-mobile.png");
      border-right-width: 0;
      border-left-width: 0;
    }
    height: 100%;
    background-image: url("../../assets/images/brand/4-2.png");
    border: 1px solid #666;
    border-bottom-width: 0;
  }
  .box-4-3 {
    height: 100%;
    border: 1px solid #666;
    border-left: none;
    border-bottom: none;
    @media (max-width: 992px) {
      border: none;
    }
  }
  .img-4-4 {
    @media (max-width: 992px) {
      background-image: url("../../assets/images/brand/4-4-mobile.png");
    }
    height: 100%;
    background-image: url("../../assets/images/brand/4-4.png");
  }
}
.box-5 {
  height: 426px;
  &.border {
    border: 1px solid #666;
    border-bottom: none;
  }
  @media (max-width: 992px) {
    height: 202px;
  }
  .img-5-1 {
    @media (max-width: 992px) {
      background-image: url("../../assets/images/brand/5-1-mobile.png");
    }
    height: 100%;
    background-image: url("../../assets/images/brand/5-1.png");
  }
  .box-5-2 {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 150px;
    font-size: 25px;
    line-height: 40px;
    text-align: left;
    color: #333;
    @media (max-width: 992px) {
      padding-left: 15px;
      font-size: 16px;
      line-height: 20px;
    }
    .big {
      font-size: 80px;
      line-height: 100px;
      @media (max-width: 992px) {
        font-size: 30px;
        line-height: 40px;
      }
    }
  }
}
.box-6 {
  height: 963px;
  @media (max-width: 992px) {
    height: auto;
  }
  &.box-6-2 {
    @media (max-width: 992px) {
      padding-left: 87px;
    }
  }
  .img-6-1 {
    background-image: url("../../assets/images/brand/6-1.png");
    background-size: contain;
    border: 1px solid #666;
    border-left: none;
    @media (max-width: 992px) {
      border-right: none;
      height: 292px;
      background-image: url("../../assets/images/brand/6-1-mobile.png");
    }
  }
  .box-6-2-1,
  .box-6-2-2 {
    height: 50%;
    .img-6-2-1 {
      @media (max-width: 992px) {
        background-image: url("../../assets/images/brand/6-2-1-mobile.png");
        border-bottom: 1px solid #666;
      }
      background-image: url("../../assets/images/brand/6-2-1.png");
    }
  }
  .box-6-2-1 {
    @media (max-width: 992px) {
      height: 193px;
    }
  }
  .box-6-2-2 {
    @media (max-width: 992px) {
      height: 308px;
      border-left: 1px solid #666;
    }
    position: relative;
    font-size: 80px;
    line-height: 90px;
    text-align: left;
    color: #333;
    background-color: #ff8a3b;
    border-bottom: 1px solid #666;
    @media (max-width: 992px) {
      font-size: 55px;
      line-height: 60px;
    }
    .text-box {
      position: absolute;
      top: -30px;
      left: -130px;
      white-space: nowrap;
      transform: rotate(-90deg);
      &.de {
        top: 0;
        left: -70px;
      }
      @media (max-width: 992px) {
        top: -20px;
        left: -110px;
        &.de {
          top: 0;
          left: -70px;
        }
      }
    }
  }
}
.box-7 {
  height: 680px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: -213px;
  @media (max-width: 992px) {
    height: 220px;
    margin-bottom: 0;
  }
  .text-box {
    margin-bottom: 20px;
    font-size: 90px;
    line-height: 100px;
    color: #333;
    @media (max-width: 992px) {
      margin-bottom: 11px;
      font-size: 35px;
      line-height: 45px;
    }
  }
  .img-7-2 {
    width: 67px;
    margin: 0 auto;
    > img {
      display: block;
      width: 100%;
    }
    @media (max-width: 992px) {
      width: 38px;
    }
  }
}
</style>